import { tracklistSchema } from "@api/tracklists/schemas";
import type { Tracklist } from "@api/tracklists/types";
import { filterTracks } from "@api/tracklists/utils";
import { z } from "zod";
import { fetchResource } from "../../utils";

export const getLastPlayerState = async (): Promise<Tracklist | undefined> => {
	const res = await fetchResource("user/player-state/last", tracklistSchema.optional());
	if (!res) return;
	return { ...res, tracks: filterTracks(res.tracks) };
};

export const postPlayerState = (state: {
	tracklistUuid: string;
	trackId: string;
	trackPlatform: string;
	time: number;
}) => fetchResource("user/player-state/report", z.object({}), "POST", state, { emptyResponse: true });

export const postPlayNotify = (uuid: Tracklist["uuid"]) =>
	fetchResource(`tracklist/${uuid}/play/notify`, z.object({}), "POST", undefined, { emptyResponse: true });
